import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { HeaderBar } from './headerBar.component';
import { selectHeaderBarTheme, selectHomeRoute } from '../../../modules/headerBar';
import { selectIsSignedIn, AuthActions } from '../../../modules/auth';
import { selectIsKioskMode } from '../../../modules/kiosk';
import { selectCurrentExperienceId } from '../../../modules/experience';

const mapStateToProps = createStructuredSelector({
  theme: selectHeaderBarTheme,
  currentHomeRoute: selectHomeRoute,
  isSignedIn: selectIsSignedIn,
  experienceId: selectCurrentExperienceId,
  isKioskMode: selectIsKioskMode,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showModal: AuthActions.showModal,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(HeaderBar);
